import React from 'react';
import { Toolbar, Stack } from '@mui/material';

export interface PanelToolbarProps {
  leftItems?: React.ReactNode;
  rightItems?: React.ReactNode;
}

export const PanelToolbar: React.FC<PanelToolbarProps> = ({ leftItems, rightItems }) => {
  return (
    <Toolbar className='lex-panel-header'>
      <Stack
        direction='row'
        spacing={2}
        alignItems='center'
        sx={{ flexGrow: 1 }}
      >
        {leftItems}
      </Stack>
      <Stack
        direction='row'
        spacing={2}
        alignItems='center'
      >
        {rightItems}
      </Stack>
    </Toolbar>
  );
};

export default PanelToolbar;
